module.exports = __webpack_public_path__ + "img/HKB.f403478c.svg";